export const fontFamilies = {
  "Arial": {
    fontWeight: true,
    fontStyle: true,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Roboto": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Open Sans": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "PT Sans": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Open Sans Condensed": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Roboto Condensed": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Montserrat Alternates": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Playfair Display SC": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Jost": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "PT Sans Caption": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Affect": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Candara": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "CentSchbkCyrill BT": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Adlery Pro": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "ALSSchlangesans-Black": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "ALSSchlangesans-Bold": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Bodoni 72": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Celestina": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Debby Script": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Cinzel": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "DIN Condensed": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Elowen": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Georgia": {
    fontWeight: true,
    fontStyle: true,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Impact": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Katona III": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Kizo": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Kosko Regular": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "MADE TheArtist Script": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Monly": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Montserrat": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Montserrat ExtraBold": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Montserrat ExtraLight": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Montserrat Thin": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Pacifico": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "PosterizerKGRough": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Proxima Nova Extrabold": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Proxima Nova Light": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Proxima Nova Regular": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Proxima Nova Semibold": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Rozovii Chulok": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Shnobel": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "AA Haymaker": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "AA Magnum": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Alabama": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "AllegroScript": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "AmazDooMRight2": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Ariadna Script": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "a_Simpler": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "BadScript": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Brusher": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Capitalist": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Champagne Cyrillic": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Coca-Cola": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Cochin": {
    fontWeight: true,
    fontStyle: true,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Code Pro Black": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Colus": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Container": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Courier New": {
    fontWeight: true,
    fontStyle: true,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "DS Rabbit": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "DS Rada_Double": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Denistina": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Fowviel": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Gabor Pro": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Game of Thrones": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Genplan Free": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Hagin Caps Thin": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "HT Skyline": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Helvetica": {
    fontWeight: true,
    fontStyle: true,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "I fink u freeky": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Intro Cond": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Jamaistevie": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Kuritza": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Lest": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Lighthaus": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Lombard": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Lumberjack": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Marker Felt": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Molot": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Mountains of Christmas C": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Movus BrushPen C": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Nathan Condensed": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Nexa Script": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Odessa Script": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Rounds Black": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Snowstorm Kraft": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Sprite Graffiti": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Tsarevich": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Ubuntu": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Uni Sans Heavy Caps": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Uni Sans Thin Caps": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Wild honey": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Wings of Darkness": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Wooden Ship Decorated": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Xiomara": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Yanone Kaffeesatz": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Zantroke": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  },
  "Zhizn": {
    fontWeight: false,
    fontStyle: false,
    linethrough: true,
    underline: true,
    shadow: true
  }
};

export const fontSizes = [
  {value: 6, label: `6`},
  {value: 7, label: `7`},
  {value: 8, label: `8`},
  {value: 9, label: `9`},
  {value: 10, label: `10`},
  {value: 11, label: `11`},
  {value: 12, label: `12`},
  {value: 14, label: `14`},
  {value: 18, label: `18`},
  {value: 24, label: `24`},
  {value: 30, label: `30`},
  {value: 36, label: `36`},
  {value: 48, label: `48`},
  {value: 60, label: `60`},
  {value: 72, label: `72`},
  {value: 96, label: `96`}
];

export const fontStyles = [
  {
    style: `fontWeight`,
    resetValue: `normal`,
    setValue: `bold`,
    tooltip: `Полужирный`
  },
  {
    style: `fontStyle`,
    resetValue: `normal`,
    setValue: `italic`,
    tooltip: `Курсив`
  },
  {
    style: `underline`,
    resetValue: false,
    setValue: true,
    tooltip: `Подчеркнутый`
  },
  {
    style: `linethrough`,
    resetValue: false,
    setValue: true,
    tooltip: `Зачеркнутый`
  },
  {
    style: `shadow`,
    resetValue: ``,
    setValue: `5px 5px 5px rgba(0,0,0,0.3)`,
    tooltip: `Тень`
  }
];

export const textAlings = [
  {
    value: `left`,
    tooltip: `Выровнять по левому краю`
  },
  {
    value: `center`,
    tooltip: `Выровнять по центру`
  },
  {
    value: `right`,
    icon: `fas fa-align-right`,
    tooltip: `Выровнять по правому краю`
  },
  {
    value: `justify`,
    tooltip: `Выровнять по ширине`
  }
];

export const lineHeight = {
  min: 0.5,
  max: 4,
  step: 0.2
};

export const pichshopFonts = {
  "Affect": true,
  "Candara": true,
  "CentSchbkCyrill BT": true,
  "Adlery Pro": true,
  "ALSSchlangesans-Black": true,
  "ALSSchlangesans-Bold": true,
  "Bodoni 72": true,
  "Celestina": true,
  "DIN Condensed": true,
  "Elowen": true,
  "Georgia": true,
  "Impact": true,
  "Katona III": true,
  "Kizo": true,
  "Kosko Regular": true,
  "MADE TheArtist Script": true,
  "Monly": true,
  "Montserrat": true,
  "Montserrat ExtraBold": true,
  "Montserrat ExtraLight": true,
  "Montserrat Thin": true,
  "Pacifico": true,
  "PosterizerKGRough": true,
  "Proxima Nova Extrabold": true,
  "Proxima Nova Light": true,
  "Proxima Nova Regular": true,
  "Proxima Nova Semibold": true,
  "Rozovii Chulok": true,
  "Shnobel": true,
  "Debby Script": true,
  "Cinzel": true
};
